import { createIconComponent } from '../../factory/create-icon-component';
export const SendingAndReceivingLocationIcon = createIconComponent(
  'SendingAndReceivingLocationIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49976 9.49958V17.2496C2.49976 17.9463 2.49976 18.2947 2.54305 18.5866C2.80157 20.3294 4.17001 21.6978 5.91283 21.9563C6.2047 21.9996 6.55305 21.9996 7.24976 21.9996L9.19157 21.9996M0.999756 10.9996L7.47427 4.52506C9.05834 2.94099 9.85037 2.14896 10.7637 1.85221C11.5671 1.59118 12.4325 1.59118 13.2358 1.85221C14.1491 2.14896 14.9412 2.94099 16.5252 4.52506L22.9998 10.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.375 14.625H12.5M19.25 12.375L21.5 14.625L19.25 16.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.625 20.375H21.5M14.75 18.125L12.5 20.375L14.75 22.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
